<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol == 'empleado'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container v-else grid-list-xl fluid>
            <v-row>
                <v-col lg="12">
                    <data-table
                        ref="tablaEstusIncidencia"
                        :tableName="'Estatus de incidencia'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        :showAdvancedFilters="false"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                    v-if="rol == 'root'"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.valor }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-row justify-center>
                <v-dialog v-model="dialog" persistent max-width="600px">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                <v-card>
                    <v-card-title class="justify-center card_titulo">
                        <div class="headerModal">
                            <img :src="imgModal" class="imgModal" />
                            <h2 class="titleModal">{{ titulo_modal }}</h2>
                        </div>
                    </v-card-title>

                    <v-card-text class="card_texto">
                        <div id="loadingModal" v-show="!finaliza_carga">
                            <div id="loading">
                                <v-progress-circular
                                    indeterminate
                                    :size="100"
                                    :width="7"
                                    color="blue"
                                ></v-progress-circular>
                            </div>
                        </div>

                    <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                        <v-divider class="divider"></v-divider>
                        <v-row>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                <v-text-field
                                    outlined
                                    label="Nombre"
                                    v-model="estatus.nombre"
                                    v-validate="'required'"
                                    data-vv-name="Nombre"
                                    :error-messages="errors.collect('Nombre')"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                <v-text-field
                                    outlined
                                    label="Valor"
                                    v-model="estatus.valor"
                                    v-validate="'required'"
                                    data-vv-name="Valor"
                                    :error-messages="errors.collect('Valor')"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end card_accion">
                        <button
                            @click="cerrarModal()"
                            class="btnCerrar"
                            :disabled="loading_guardar"
                        >
                            Cancelar
                        </button>
                        <v-btn
                            class="btnGuardar"
                            @click="guardar()"
                            :loading="loading_guardar"
                        >
                            Guardar
                        </v-btn> 
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-row>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import estatusApi from "../api/estatusIncidencias";
import Datatable from "@/components/datatable/Datatable.vue";
import Notify from "@/plugins/notify";
import PerfectScrollbar from "perfect-scrollbar";

export default {
    components: {
        "data-table": Datatable,
    },
    data() {
        return {
            url: "catalogo/estatus-incidencias/find",
            columns: [
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: false,
                },
                {
                    label: "Valor",
                    name: "valor",
                    filterable: false,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                },
            ],
            filters: {
                activo: true,
                paginate: true,
            },
            advancedSearch: {
                nombre: null,
            },
            loading_guardar: false,
            loading: true,
            dialog: false,
            search: "",
            datosLogin: "",
            complex: {
                selected: [],
                headers: [
                {
                    text: "Nombre",
                    value: "nombre",
                },
                {
                    text: "Valor",
                    value: "valor",
                },
                {
                    text: "Opciones",
                    value: "",
                },
                ],
                items: [],
            },
            estatus: {
                id: 0,
                nombre: "",
                valor: "",
            },
            titulo_modal: "",
            finaliza_carga: false,
            action: "",
            rol: "",
            datosLogin: "",
            imgModal : "/static/modal/estatusIncidencia.svg",
            
        };
    },
    methods: {
        listar() {
            this.resetValues();
            this.loading = true;
            this.datosLogin = this.$session.get("usuario");
        },
        setFilters() {
            let nombre = this.advancedSearch.nombre;

            let filtersParams = {
                nombre: nombre,
            };
            let defaultParams = {
                activo: true,
                paginate: true,
            };
            if (filtersParams != null) {
                Object.assign(defaultParams, filtersParams);
            }

            this.filters.defaultParams;
            this.advancedSearch.nombre = null;
        },
        abrirModal(accion, item = null) {
            this.errors.clear();
            this.accion = accion;
            if (accion == "add") {
                this.titulo_modal = "Registro de estatus de incidencias";
            } else {
                this.titulo_modal = "Actualizar estatus de incidencias";
                this.estatus.id = item.id;
                this.estatus.nombre = item.nombre;
                this.estatus.valor = item.valor;
            }
            this.finaliza_carga = true;
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;
                    if (this.accion === "add") {
                        estatusApi.addEstatusincidencia(this.estatus).then((response) => {
                            this.$refs.tablaEstusIncidencia.getData();
                            this.respuesta_ok("Registro creado con exito");
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } else if (this.accion === "update") {
                        estatusApi.updateEstatusincidencia(this.estatus).then((response) => {
                            this.$refs.tablaEstusIncidencia.getData();
                            this.respuesta_ok("Registro actualizado correctamente");
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        cerrarModal() {
            this.dialog = false;
            this.resetValues();
        },
        resetValues() {
            this.estatus.id = 0;
            this.estatus.nombre = "";
            this.estatus.valor = "";
            this.loading_guardar = false;
        },
        eliminar(id, estatus) {
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el estatus incidencia " +
                estatus +
                "?",
                "Eliminar",
                () => {
                    estatusApi.deleteEstatusincidencia(id).then((response) => {
                        this.$refs.tablaEstusIncidencia.getData();
                        this.respuesta_ok("El estatus de incidencia ha sido eliminado satisfactoriamente");
                    })
                    .catch((err) => {
                        console.log(err);
                        Notify.ErrorToast(err.response.data.error);
                    });
                }
            );
        },
        respuesta_error(err) {
            this.cerrarModal();
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
    },
    created() {
        this.listar();
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;
    },
};
</script>
